import { useContextMenu } from "./useContextMenu";

import { usePlatformDetection } from "./usePlatformDetection";

import { useWindowControls } from "./useWindowControls";

interface UseTitleBarProps {
  visible: boolean;

  height: number;
}

export const useTitleBar = ({ visible, height }: UseTitleBarProps) => {
  const platform = usePlatformDetection();

  const windowControls = useWindowControls();

  const contextMenu = useContextMenu();

  const isMac = platform === "darwin";

  // La barra se renderiza en TODAS las plataformas (item #7 plan mac): antes

  // se ocultaba entera en darwin, dejando la app mac sin Go Live/Record/menú/

  // perfil. En mac se muestran el chrome de app pero NO los botones win

  // min/max/close (macOS usa los semáforos nativos) — ver `isMac` abajo.

  const shouldRender = visible;

  return {
    shouldRender,

    platform,

    isMac,

    height,

    ...windowControls,

    ...contextMenu,
  };
};
